<template>
  <div>
    <div class="hide-on-print">
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Permissões"
      />
    </div>
    <filters @filter="handleFilter" :loading="loading" />
    <PermissionsTable 
      :user-ids="selectedUserIds" 
      :role-ids="selectedRoleId" 
      :permission-ids="selectedPermissionId"
      :loading.sync="loading"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import PageTitle from "@/layouts/PageTitle";
import Filters from "./components/permission/Filters.vue";
import PermissionsTable from "./components/permission/PermissionsTable.vue";

const selectedUserIds = ref([]);
const selectedRoleId = ref([]); 
const selectedPermissionId = ref([]);
const loading = ref(false);

const handleFilter = ({ userIds, roleId, permissionIds }) => {
  selectedUserIds.value = userIds;
  selectedRoleId.value = roleId;
  selectedPermissionId.value = permissionIds;
};
</script>
